let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2nh75"), load("acQiP")]).then(() => parcelRequire('3gPdG'));